import React from "react";
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useAllPurchases from "./useAllPurchases";

const AllPurchases = () => {
  const { drawerMenu } = useAllPurchases();
  return (
    <CommonLayout drawerMenu={drawerMenu} >
      <Outlet />
    </CommonLayout>
  );
};

export default AllPurchases;
